
<div *ngIf="!hideActionBar" appearance="secondary" class="cn-action-bar-bottom">
  <div class="cn-owc-button-row" style="display: flex; gap: 24px; padding: 18px">
    <div class="cn-owc-button-box">
      <owc-button #buttonElement (click)="discardDraftNotification()" [disabled]="isButtonDisabled">
        Delete
      </owc-button>
    </div>
    <div class="cn-owc-button-box">
      <owc-button #buttonElement (click)="saveCloseNotification()" [disabled]="isButtonDisabled">
        Save and close
      </owc-button>
    </div>
    <div class="cn-owc-button-box">
      <owc-button #buttonElement (click)="btnPrevNextStepClicked('prev')" [disabled]="btnState.isPrevDisabled || isButtonDisabled">
          Previous step
      </owc-button>
    </div>
    <div class="cn-owc-button-box">
      <owc-button #buttonElement (click)="btnPrevNextStepClicked('next')" *ngIf="!btnState.isNextDisabled" [disabled]="btnState.isNextDisabled || isButtonDisabled" >
          Next step
      </owc-button>
      <owc-button #buttonElement (click)="btnSendNotificationClicked()" *ngIf="btnState.isNextDisabled && userPermission.SendNotification" [disabled]="isSendNotificationEnabled || isButtonDisabled || isSendNotificationClicked" >
        Send Notification
    </owc-button>
    </div>
  </div>
</div>

<!-- Confirmation Dialog for unsaved feedback -->
<owc-modal-dialog size="medium" [(ngModel)]="confirmationDialogVisible" >
  <h4 slot="header">{{ confirmationDialogData.title }}</h4>
  <div style="padding: 0 20px 20px">
    <owc-typography variant="body2">
      {{ confirmationDialogData.message }}
    </owc-typography>
  </div>
  <owc-component-footer style="display: flex; justify-content: flex-start; padding:  0 20px 20px 20px;" slot="footer">
    <owc-button (click)="onConfirmationDialogClose()" color="primary" style="min-width: 80px;">
      {{ confirmationDialogData.confirmButtonText }}
    </owc-button>
  </owc-component-footer>
</owc-modal-dialog>

    <!-- Confirmation Dialog for unsaved feedback -->
   <owc-modal-dialog size="medium" [(ngModel)]="confirmationDialogVisible" >
     <h4 slot="header">{{ confirmationDialogData.title }}</h4>
     <div style="padding: 0 20px 20px">
        <owc-typography variant="body2">
          {{ confirmationDialogData.message }}
        </owc-typography>
      </div>
      <owc-component-footer style="display: flex; justify-content: flex-start; padding:  0 20px 20px 20px;" slot="footer">
        <owc-button (click)="onConfirmationDialogClose()" color="primary" style="min-width: 80px;">
          {{ confirmationDialogData.confirmButtonText }}
        </owc-button>
      </owc-component-footer>
    </owc-modal-dialog>

    <!-- Delete Draft Notification Dialog -->
    <owc-modal-dialog size="small" [(ngModel)]="deleteDialogVisible">
      <owc-component-header slot="header">{{ deleteDialogData.title }}</owc-component-header>
      <div style="margin:10px auto 20px 17px">
        <owc-typography variant="body2">
          {{ deleteDialogData.message }}
        </owc-typography>
      </div>
      <owc-component-footer slot="footer">
        <div style="display: flex; align-items: center;margin-left: auto; display: flex; gap: 10px;">
          <owc-button (click)="onDeleteDialogCancel()" style="background-color: #ffffff !important;color: #0066CC !important;border: 1px solid #ced2d6 !important;">{{ deleteDialogData.cancelButtonText }}</owc-button>
          <owc-button (click)="onDeleteDialogConfirm()" color="primary">{{ deleteDialogData.confirmButtonText }}</owc-button>
        </div>
      </owc-component-footer>
    </owc-modal-dialog>
